import React from 'react'
import { Column } from '../../entities/column/Column'
import OrdersColumn from '../orders-column/OrdersColumnContainer'

import { styled } from '@mui/material/styles'

export interface IOwnProps {
  columns: Column[]
  className?: string
}

export type IProps = IOwnProps

//import messages from './OrdersColumns.messages'

const OrdersColumns:React.FC<IProps> = (props) => {
  const {
    columns,
    className,
  } = props

  return (
    <div className={className} >
      {
        columns.map(column => (
          <OrdersColumn
            key={column.name}
            title={column.name}
            cycles={column.cycles}
            productsCount={column.productsCount}
          />
        ))
      }
    </div>
  )
}

export default styled(OrdersColumns)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '2fr 2fr 1fr',
  gridColumnGap: theme.spacing(2),
  placeSelf: 'stretch',
  alignItems: 'stretch',
  paddingBottom: theme.spacing(3),
}))
